import React from 'react';
import { getWarrantyStatus } from '../utils/warranty';
import { Shield } from 'lucide-react';

/**
 * Shows warranty status as a colored badge.
 * Accepts either:
 * - warranty_period + purchased_date (calculates live)
 * - Or pre-computed warranty_status (boolean legacy)
 */
export default function WarrantyBadge({ warrantyPeriod, purchasedDate, small }) {
  const ws = getWarrantyStatus(purchasedDate, warrantyPeriod);

  if (ws.status === 'none') return <span style={{ color: '#334155', fontSize: small ? 10 : 11 }}>—</span>;

  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 1 }}>
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        padding: small ? '1px 6px' : '2px 8px',
        borderRadius: 20, fontSize: small ? 10 : 11, fontWeight: 600,
        background: `${ws.color}15`, color: ws.color, border: `1px solid ${ws.color}30`,
        whiteSpace: 'nowrap'
      }}>
        <Shield size={small ? 9 : 10}/>{ws.label}
      </span>
      {ws.expiryDate && !small && (
        <span style={{ color: '#334155', fontSize: 10, paddingLeft: 4 }}>Expires: {ws.expiryDate}</span>
      )}
    </div>
  );
}
